import { render, staticRenderFns } from "./ambientelist.vue?vue&type=template&id=9bf00caa"
import script from "./ambientelist.vue?vue&type=script&lang=js"
export * from "./ambientelist.vue?vue&type=script&lang=js"
import style0 from "./ambientelist.vue?vue&type=style&index=0&id=9bf00caa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports